import styled from "styled-components";

// we'll need to move the .pilotly-register class styling along with styles for it's children to this MainStyles file - EG
export const PilotlyRegister = styled.div`
	height: 100vh;

	p, h1, h2, h3, h4, h5 {
		margin: 0px;
		color: white;
		font-weight: 300;
	}
`;

export const RegisterFormWrapper = styled.div`
	width: 75%;
	margin: auto;
	position: relative;
	top: 175px;
`;


// WEBPACK FOOTER //
// ./src/components/global/Styles/MainStyles.js